<script setup lang="ts">
import { defineProps } from 'vue'
import Message from './Message.vue'

const {
    messages = [],
    count = 0,
} = defineProps({
    messages: Array,
    count: [Number, String, null],
})

const messageClickHandler = (message) => {
    location.href = message.link;
}
</script>

<template>
    <div class="messages-container">
        <div class="messages-container-header">
            Сообщения ({{ count }})
        </div>

        <div class="messages-container-content">
            <span v-if="!messages.length" class="empty-messages">
                У вас нет новых сообщений
            </span>

            <div v-else>
                <Message
                    v-for="message in messages"
                    :key="message.id"
                    @click="messageClickHandler(message)"
                    :message
                />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use "assets/styles/variables" as *;

.messages-container {
    width: 300px;
    position: absolute;
    background-color: #fff;
    z-index: 1;
    top: calc(100% + 8px);
    right: 0;
    box-shadow: 0 1px 5px 0 #041B2D26, 0 1px 5px 1px #041B2D26;
    cursor: initial;
    font-size: 14px;

    &-header {
        background-color: $color-primary-lighter-2;
        padding: 12px;
    }

    .messages-container-header {
        font-weight: 500;
    }

    .messages-container-content {
        max-height: 45vh;
        overflow-y: auto;
        scrollbar-width: thin;
    }

    .empty-messages {
        color: #999;
    }

    &-content {
        padding: 12px;
    }
}
</style>
